import React from 'react';
import { useLocale } from '../context/LocaleContext';
import { Step5InventoryPresentationRecord } from '../types/step5InventoryPresentation';
import styles from '../styles/stepCommon.module.css';

interface Step5InventoryPresentationFieldsProps {
  value: Step5InventoryPresentationRecord;
  onChange: (next: Step5InventoryPresentationRecord) => void;
  disabled?: boolean;
}

const Step5InventoryPresentationFields: React.FC<Step5InventoryPresentationFieldsProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  const { t } = useLocale();

  const patch = (fields: Partial<Step5InventoryPresentationRecord>) => {
    onChange({ ...value, ...fields });
  };

  return (
    <div className={styles.actionFieldsPanel}>
      <div className={styles.actionFieldGroup}>
        <div className={styles.actionFieldRow}>
          <label className={styles.actionFieldLabel} htmlFor="step5-presentation-started">
            {t('step.5.presentation.started_label')}
          </label>
          <input
            id="step5-presentation-started"
            type="date"
            className={styles.actionFieldInput}
            value={value.startedDate || ''}
            onChange={(e) => patch({ startedDate: e.target.value })}
            disabled={disabled}
          />
        </div>
        <div className={styles.actionFieldRow}>
          <label className={styles.actionFieldLabel} htmlFor="step5-presentation-place">
            {t('step.5.presentation.place_label')}
          </label>
          <input
            id="step5-presentation-place"
            type="text"
            className={styles.actionFieldInput}
            value={value.place || ''}
            onChange={(e) => patch({ place: e.target.value })}
            placeholder={t('step.5.presentation.place_placeholder')}
            disabled={disabled}
            maxLength={200}
          />
        </div>
        <div className={styles.actionFieldRow}>
          <label className={styles.actionFieldLabel} htmlFor="step5-presentation-reflection">
            {t('step.5.presentation.reflection_label')}
          </label>
          <textarea
            id="step5-presentation-reflection"
            className={styles.actionFieldTextarea}
            value={value.reflection || ''}
            onChange={(e) => patch({ reflection: e.target.value })}
            placeholder={t('step.5.presentation.reflection_placeholder')}
            rows={3}
            disabled={disabled}
            maxLength={2000}
          />
        </div>
      </div>
    </div>
  );
};

export default Step5InventoryPresentationFields;
